import { useMemo } from 'react';

import { formatDateForAPI } from '@/utils/dates.utils';

import type { ConsumerViewParams } from '../types/consumer.types';

import useConsumerStore from '../store/consumer.store';

export const useConsumerViewParams = (): ConsumerViewParams | null => {
  const { dateRange, companies, cups } = useConsumerStore();

  return useMemo((): ConsumerViewParams | null => {
    if (!dateRange?.[0] || !dateRange?.[1]) return null;

    // Group cups by companyId
    const cupsByCompany: Record<string, number[]> = {};

    cups.forEach((cup) => {
      const companyKey = String(cup.companyId);

      if (!cupsByCompany[companyKey]) {
        cupsByCompany[companyKey] = [];
      }

      cupsByCompany[companyKey].push(cup.id);
    });

    // Sort identifiers within each company
    Object.keys(cupsByCompany).forEach((key) => {
      cupsByCompany[key].sort();
    });

    return {
      startDate: formatDateForAPI(dateRange[0]),

      endDate: formatDateForAPI(dateRange[1]),

      companies: companies.map((c) => c.id),

      cups: cupsByCompany,
    };
  }, [dateRange, companies, cups]);
};
